import Vue from 'vue'
import axios from 'axios'
import _, {isPlainObject, round} from 'lodash'
import printJS from 'print-js'
import {
    DOC_METADATA_BUILD_ERRORS_LIST,
    DOC_METADATA_GENERATE_FOR_LINE,
    DOC_METADATA_REMOVE_FOR_LINE,
    DOC_METADATA_TOUCH_FIELD
} from './metadata'
import EventBus from '../../../command/bus'
import {equalWithDispersion, forceToNumber} from '@/utils'
import {
    getDocTotalValues,
    getLinePriceExcessLevelByPercentage,
    getLinePriceExcessPercentage,
    getLinesTaxSum,
    getLinesTaxSumBasedOnTaxRate,
    getLinesTotalSum,
    getLineValues,
    getSplitSumPercentage,
    getStatementLineValues
} from '@/utils/document'
import {Raven} from 'vue-raven'
import moment from 'moment'
import {getFieldPathMeta} from '@/types/document-viewer/field/modules/path'
import {FieldActionTypes} from '@/types/document-viewer/field/modules/action'
import {LineTotalCalculationFormulas} from '@/types/document-viewer/extension/calculate/lines/total'
import {DocTotalCalculationFormulas} from '@/types/document-viewer/extension/calculate/totals/total'
import {DocTaxCalculationFormulas} from '@/types/document-viewer/extension/calculate/totals/tax'
import {FieldEditorTypes} from '@/types/document-viewer/field/modules/editor'
import {DOC_SETTINGS_SETUP_WITH_METADATA} from './settings'
import {DOC_PO_CHECK, DOC_PO_ON_UNMATCH, DOC_PO_SET} from './matching/purchase-order'
import {DOC_RECEIPT_ON_UNMATCH, DOC_RECEIPT_SET} from './matching/supplier-receipt'
import {TaxTreatmentCodes} from '@/models/document'
import {FormSystemSections} from '@/types/document-viewer/section'
import {AppDocLineTypes} from '@/types/document/lines'
import {AppDocSystemStatuses, AppDocSystemStatusGroups} from '@/types/document/status'
import {ProductUomConversionOperatorTypes} from '@/types/data/product'
import {
    AppDocSystemTypes,
    convertDocumentSectionForDocumentsAPI,
    getDocSystemTypeDefaultModel
} from '@/types/document/types'
import {AppDocSystemSubtypes} from '@/types/document/subtypes'
import {documentApi} from '@/api/document'
import {$lang} from '@/views/settings/team/lang'
import {priceAlertLevels} from '@/types/document/price-alerts'
import {calculateDocLineTax, calculateDocLineTotal} from '@/utils/document/calculations/lines'
import {AppDocPageMimeTypes} from '@/types/document'
import {showErrorMessage, showInfoMessage, showSuccessMessage} from '@/services/snackbar'
import {removeDashesAndWhitespace} from '@/utils/string'
import {demoContractApi} from '@/api/document/demo-contracts'
import {getDependentFieldLabel, getFieldDependencyQueryParams} from '@/types/document-viewer/field/modules/dependencies'

export const DOC_SET = 'DOC_SET' // mutation and action
// mutations
export const DOC_SET_LINES = 'DOC_SET_LINES'
export const DOC_SET_NOTES = 'DOC_SET_NOTES'
export const DOC_SET_ALLOCATIONS = 'DOC_SET_ALLOCATIONS'
export const DOC_SET_USERS = 'DOC_SET_USERS'
export const DOC_SET_COMPANY = 'DOC_SET_COMPANY'
export const DOC_SET_CUSTOM_FIELDS = 'DOC_SET_CUSTOM_FIELDS'

export const DOC_SET_FIELD = 'DOC_SET_FIELD'
export const DOC_SET_CUSTOM_FIELD = 'DOC_SET_CUSTOM_FIELD'
export const DOC_SET_COMPANY_FIELD = 'DOC_SET_COMPANY_FIELD'
export const DOC_SET_LINE_FIELD = 'DOC_SET_LINE_FIELD'

export const DOC_FIELD_UPDATE = 'DOC_FIELD_UPDATE'
export const DOC_LINES_BATCH_UPDATE = 'DOC_LINES_BATCH_UPDATE'

export const DOC_DUPLICATES_CHECK = 'DOC_DUPLICATES_CHECK'
export const DOC_ABN_CHECK = 'DOC_ABN_CHECK'
export const DOC_SET_STATUS = 'DOC_SET_STATUS'
export const DOC_SET_LOCATION = 'DOC_SET_LOCATION'
export const DOC_SET_SUBSIDIARY = 'DOC_SET_SUBSIDIARY'
export const DOC_CANCEL_SCAN = 'DOC_CANCEL_SCAN'

export const DOC_SET_APPROVAL = 'DOC_SET_APPROVAL'
export const DOC_NOTE_ADD = 'DOC_NOTE_ADD'
export const DOC_NOTE_UPDATE = 'DOC_NOTE_UPDATE'

export const DOC_LINE_ADD = 'DOC_LINE_ADD'
export const DOC_LINE_DUPLICATE = 'DOC_LINE_DUPLICATE'
export const DOC_LINE_REMOVE = 'DOC_LINE_REMOVE'
export const DOC_LINE_ALTERNATIVE_ALERT = 'DOC_LINE_ALTERNATIVE_ALERT'
export const DOC_LINE_ON_CHANGE_SKU = 'DOC_LINE_ON_CHANGE_SKU'
export const DOC_LINE_CLEAR_SKU_AND_DETACH_ITEM = 'DOC_LINE_CLEAR_SKU_AND_DETACH_ITEM'
export const DOC_LINE_OVERRIDE_DATA_FOR_SELECTED_ITEM = 'DOC_LINE_OVERRIDE_DATA_FOR_SELECTED_ITEM'

export const DOC_LINE_UOM_CALCULATE_CONVERTED_QTY = 'DOC_LINE_UOM_CALCULATE_CONVERTED_QTY'
export const DOC_LINE_UOM_CALCULATE_PRICE = 'DOC_LINE_UOM_CALCULATE_PRICE'
export const DOC_LINE_UOM_CALCULATE_BASE_PRICE = 'DOC_LINE_UOM_CALCULATE_BASE_PRICE'
export const DOC_LINE_UOM_SET_PRICE_FROM_ITEM_CONVERSION_TABLE = 'DOC_LINE_UOM_SET_PRICE_FROM_ITEM_CONVERSION_TABLE'
export const DOC_LINE_UOM_FIND_CONVERSION = 'DOC_LINE_UOM_FIND_CONVERSION'

export const DOC_FIELD_RUN_ACTIONS = 'DOC_FIELD_RUN_ACTIONS'
export const DOC_SAVE_CHANGES = 'DOC_SAVE_CHANGES'
export const DOC_ADJUST_DATA_FOR_API = 'DOC_ADJUST_DATA_FOR_API'
export const DOC_ADD_HIDDEN_FIELDS_INTO_MODEL = 'DOC_ADD_HIDDEN_FIELDS_INTO_MODEL'
export const DOC_ADJUST_LINES_TYPE = 'DOC_ADJUST_LINES_TYPE'
export const DOC_REMOVE_EMPTY_LINES = 'DOC_REMOVE_EMPTY_LINES'
export const DOC_FILL_SUPPLIER = 'DOC_FILL_SUPPLIER'
export const DOC_CLEAN_SUPPLIER = 'DOC_CLEAN_SUPPLIER'
export const DOC_FILL_ADDRESS = 'DOC_FILL_ADDRESS'

export const DOC_RECALCULATE_TOTAL = 'DOC_RECALCULATE_TOTAL'
export const DOC_RECALCULATE_SUBTOTAL = 'DOC_RECALCULATE_SUBTOTAL'
export const DOC_RECALCULATE_TAX = 'DOC_RECALCULATE_TAX'
export const DOC_RECALCULATE_FREIGHT = 'DOC_RECALCULATE_FREIGHT'
export const DOC_RECALCULATE_LINE_TOTAL = 'DOC_RECALCULATE_LINE_TOTAL'
export const DOC_RECALCULATE_EACH_LINE_TOTAL = 'DOC_RECALCULATE_EACH_LINE_TOTAL'
export const DOC_RECALCULATE_LINE_TAX = 'DOC_RECALCULATE_LINE_TAX'
export const DOC_RECALCULATE_LINES_SPLIT = 'DOC_RECALCULATE_LINES_SPLIT'
export const DOC_AUTOCOMPLETE_STATEMENT_LINE_TOTALS_AND_TYPE = 'DOC_AUTOCOMPLETE_STATEMENT_LINE_TOTALS_AND_TYPE'
export const DOC_SET_IS_SAVING_CHANGES = 'DOC_SET_IS_SAVING_CHANGES'
export const DOC_VIEWER_PRINT = 'DOC_VIEWER_PRINT'
export const DOC_FETCH_RELATED_DOCUMENTS = 'DOC_FETCH_RELATED_DOCUMENTS'
export const DOC_SET_RELATED_DOCUMENTS = 'DOC_SET_RELATED_DOCUMENTS'
export const DOC_CLEAR_RELATED_DOCUMENTS = 'DOC_CLEAR_RELATED_DOCUMENTS'
export const DOC_SET_TAGS = 'DOC_SET_TAGS'

export const DOC_CLEAR_DEPENDENT_FIELD_VALUES = 'DOC_CLEAR_DEPENDENT_FIELD_VALUES'

export const DOC_SET_CONTRACT_CHECK_RESPONSE = 'DOC_SET_CONTRACT_CHECK_RESPONSE'

export const state = {
    doc: {},

    // (!) normalized doc parts:
    users: [],
    lines: [],
    notes: [],
    allocations: [],
    custom: {},
    company: {
        custom: {}
    },

    relatedDocumentsInfo: {
        groups: {},
        docs: []
    },

    approval: null,
    isSavingChanges: false,

    checkContractResponse: []
}

export const getters = {
    doc: state => state.doc || {}, // without normalized parts
    docWithNormalizedParts: (state, getters, rootState, rootGetters) => {
        if (!getters.doc.uuid) {
            return {}
        }
        return {
            ...getters.doc,
            [getters.linesPropName]: getters.lines,
            company: getters.company,
            notes: getters.notes,
            tags: getters.tags,
            allocations: getters.allocations,
            users: getters.users,
            custom: getters.custom,
            purchaseOrder: rootGetters['doc_viewer_po/purchaseOrder'],
            deliveryDocket: rootGetters['doc_viewer_supplier_receipt/deliveryDocket']
        }
    },

    users: state => state.users || [],
    lines: state => state.lines || [],
    notes: state => state.notes || [],
    tags: state => state.tags || [],
    allocations: state => state.allocations || [],
    custom: state => state.custom || {},
    company: state => state.company || {custom: {}},
    relatedDocsList: state => state.relatedDocumentsInfo.docs,
    relatedDocsGroups: state => state.relatedDocumentsInfo.groups,
    visibleNotes: state => state.notes.filter(n => !n.isDeleted),
    hasAtLeastOneNonEmptyNote: (state, getters) => getters.visibleNotes.some(n => n.body),

    // NOTE: do not use where the original line index is needed
    notDeletedLines: (state, getters) => getters.lines.filter(l => l && !l.isDeleted),

    approval: state => state.approval,
    isEditableApprovalDoc: state => state.approval && state.approval.canEdit,
    checkIsUserInDocApprovalFlow: (state, getters) => userId => {
        if (getters.approval && _.isArray(getters.approval.steps)) {
            return getters.approval.steps.some(s => s.users && s.users.some(u => u.user && u.user.uuid === userId))
        }
    },

    dt: (state, getters, rootState, rootGetters) => rootGetters['documents/getDocumentTypeModel'](getters.doc),
    status: (state, getters, rootState, rootGetters) => rootGetters['documents/getDocumentStatusModel'](getters.doc),
    section: (state, getters) => getDocSystemTypeDefaultModel(getters.dt.type),
    entityName: (state, getters) => getters.section.uriSingular, // sale | invoice | statement

    pages: (state, getters) => _.isArray(getters.doc.pages) ? getters.doc.pages : [],
    firstPage: (state, getters) => getters.pages[0] || {},
    isDocWithAssets: (state, getters) => !!getters.firstPage.image,
    pipeline: state => state.doc.pipeline || {},
    hasCognitiveVisionData: (state, getters) => {
        return !!getters.pipeline.supplier || !!getters.pipeline.template
    },

    isScanningDoc: (state, getters) => getters.status.key === AppDocSystemStatuses.SCANNING,
    isFlaggedDoc: (state, getters) => getters.status.key === AppDocSystemStatuses.FLAGGED,
    isFlaggedHiddenDoc: (state, getters) => getters.status.key === AppDocSystemStatuses.FLAGGED_HIDDEN,
    isProcessingDoc: (state, getters) => getters.status.key === AppDocSystemStatuses.PROCESSING,
    isCompletedDoc: (state, getters) => getters.status.type === AppDocSystemStatuses.COMPLETE, // group
    isApprovalDoc: (state, getters) => [AppDocSystemStatuses.APPROVE, AppDocSystemStatuses.APPROVAL].includes(getters.status.type), // group
    isRejectedDoc: (state, getters) => getters.status.key === AppDocSystemStatuses.REJECT,
    isReviewDoc: (state, getters) => getters.status.key === AppDocSystemStatuses.REVIEW,

    isSystemDoc: (state, getters) => !!getters.dt.isSystem,
    isSales: (state, getters) => getters.dt.type === AppDocSystemTypes.SALES,
    isPurchases: (state, getters) => getters.dt.type === AppDocSystemTypes.PURCHASING,
    isStatements: (state, getters) => getters.dt.type === AppDocSystemTypes.STATEMENTS,
    isBatches: (state, getters) => getters.dt.type === AppDocSystemTypes.BATCHES,
    isDeliveryDocket: (state, getters) => getters.doc.type === AppDocSystemSubtypes.DELIVERY_DOCKET,
    isExpenseSplit: (state, getters) => getters.doc.type === AppDocSystemSubtypes.EXPENSE_SPLIT,
    isCustomDoc: (state, getters) => !getters.isSystemDoc,

    isSavingChanges: state => state.isSavingChanges,

    dtStatuses: (state, getters) => {
        return getters.dt.statuses ? getters.dt.statuses.filter(s => ![s, s.key].includes(AppDocSystemStatuses.FLAGGED_HIDDEN)) : []
    },

    disabledDocument: (state, getters, rootState, rootGetters) => {
        if (getters.isApprovalDoc && getters.isEditableApprovalDoc) {
            return false
        }
        return !rootGetters['doc_viewer_access_level/canEditDoc'] ||
            [
                AppDocSystemStatuses.REJECT,
                AppDocSystemStatuses.SCANNING,
                AppDocSystemStatuses.FLAGGED_HIDDEN,
                AppDocSystemStatuses.PROCESSING
            ].includes(getters.status.key) ||
            getters.isApprovalDoc ||
            getters.isCompletedDoc
    },

    // Supplier
    matchingSupplier: (state, getters) => getters.company.supplier,
    matchingSupplierBankDetails: (state, getters) => {
        if (getters.matchingSupplier &&
            getters.matchingSupplier.bank &&
            (getters.matchingSupplier.bank.bsb || getters.matchingSupplier.bank.account)) {
            return getters.matchingSupplier.bank
        }
    },
    showInvalidBankDetailsAlert: (state, getters, rootState, rootGetters) => {
        return rootGetters['doc_viewer_settings/checkContactBankDetails'] &&
            !getters.hasMatchedBankAccount
    },

    hasMatchedBankAccount: (state, getters) => {
        if (isPlainObject(getters.matchingSupplier) &&
            isPlainObject(getters.matchingSupplierBankDetails) &&
            (getters.company.bank_bsb || getters.company.bank_account) &&
            (getters.matchingSupplierBankDetails.bsb || getters.matchingSupplierBankDetails.account)) {
            return removeDashesAndWhitespace(getters.company.bank_bsb).toLowerCase() ===
                removeDashesAndWhitespace(getters.matchingSupplierBankDetails.bsb).toLowerCase() &&
                removeDashesAndWhitespace(getters.company.bank_account).toLowerCase() ===
                removeDashesAndWhitespace(getters.matchingSupplierBankDetails.account).toLowerCase()
        }
        return true
    },
    allowAbnCheck: (state, getters, rootState, rootGetters) => {
        if (!rootGetters['doc_viewer_settings/checkContactABN']) {
            return false
        }
        const isVisibleTaxField = rootGetters['doc_viewer_settings/checkIsVisibleFieldByPath']('tax')
        return (isVisibleTaxField ? forceToNumber(getters.doc.tax) > 0 : true) &&
            getters.company.tax &&
            getters.company.abn
    },
    isValidAbn: (state, getters) => {
        return getters.isActiveAbn && getters.hasRegisteredAbn
    },
    isActiveAbn: (state, getters) => {
        return getters.company.abn && getters.company.abn.status === 'Active'
    },
    hasRegisteredAbn: (state, getters) => {
        return getters.company.abn && getters.company.abn.salesTax_at &&
            moment(getters.company.abn.salesTax_at).isValid()
    },
    getDocAssignedUserUuids: (state, getters) => {
        if (_.isArray(getters.users) && getters.users.length !== 0) {
            return getters.users
        }
        // previously added user in 'user' prop, now only 'users' array is used
        const user = _.find(getters.getMembers, {'uuid': getters.doc.user})
        return user && user.uuid ? [user.uuid] : []
    },

    linesPropName: (state, getters) => getters.isStatements ? 'statementLines' : 'lines',

    docTaxTreatmentCode: (state, getters) => getters.doc.taxTreatment ? getters.doc.taxTreatment.uuid : null,
    linesTaxSum: (state, getters, rootState, rootGetters) => {
        return getLinesTaxSum(
            getters.notDeletedLines,
            rootGetters['doc_viewer_settings/defaultRounding'])
    },
    linesTaxSumBasedOnTaxRate: (state, getters, rootState, rootGetters) => {
        return getLinesTaxSumBasedOnTaxRate(
            getters.notDeletedLines,
            rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('lines.tax'),
            getters.docTaxTreatmentCode)
    },
    linesTaxSumForSelectedCalculationFormula: (state, getters, rootState, rootGetters) => {
        if (rootGetters['doc_viewer_settings/calculateDocTaxFormulaKey'] === DocTaxCalculationFormulas.TAX_EQUAL_LINES_TAX_SUM) {
            return getters.linesTaxSum
        } else if (rootGetters['doc_viewer_settings/calculateDocTaxFormulaKey'] === DocTaxCalculationFormulas.TAX_EQUAL_LINES_TAX_SUM_BASED_ON_TAX_RATE) {
            return getters.linesTaxSumBasedOnTaxRate
        }
        return 0
    },
    linesTotalsSum: (state, getters, rootState, rootGetters) => {
        return getLinesTotalSum(
            getters.notDeletedLines, // && l.type === 'ITEM' ?
            rootGetters['doc_viewer_settings/defaultRounding'])
    },
    splitSumPercentage: (state, getters, rootState, rootGetters) => {
        return rootGetters['doc_viewer_settings/hasLinesSplitAndTotal']
            ? getSplitSumPercentage(getters.notDeletedLines)
            : 0
    },
    incorrectSplitSum: (state, getters) => !equalWithDispersion(getters.splitSumPercentage, 100),

    docUniqueLocations: (state, getters) => {
        if (getters.isSystemDoc) {
            return _.uniqWith(getters.notDeletedLines.map(line => line.location), _.isEqual)
        } else if (getters.isCustomDoc && getters.doc.locations && getters.doc.locations[0] && getters.doc.locations[0].uuid) {
            return [getters.doc.locations[0]]
        }
        return []
    },

    docUniqueSubsidiaries: (state, getters) => {
        if (getters.isSystemDoc) {
            return _.uniqWith(getters.notDeletedLines.map(line => line.subsidiary), _.isEqual)
        } else if (getters.isCustomDoc && getters.doc.subsidiaries && getters.doc.subsidiaries[0] && getters.doc.subsidiaries[0].uuid) {
            return [getters.doc.subsidiaries[0]]
        }
        return []
    },

    priceAlertPropertyName: (state, getters, rootState, rootGetters) => {
        return rootGetters['doc_viewer_settings/withLineUomConversion'] ? 'basePrice' : 'price'
    },

    linesWithPriceAboveBlockingLevel: (state, getters, rootState, rootGetters) => {
        return getters.notDeletedLines.filter(line => {
            return priceAlertLevels.block.key === getLinePriceExcessLevelByPercentage({
                percentage: getLinePriceExcessPercentage({line: line, priceProperty: getters.priceAlertPropertyName}),
                levels: rootGetters.priceAlerts
            })
        })
    },

    linesWithPriceAboveWarningLevel: (state, getters, rootState, rootGetters) => {
        return getters.notDeletedLines.filter(line => {
            return priceAlertLevels.warning.key === getLinePriceExcessLevelByPercentage({
                percentage: getLinePriceExcessPercentage({line, priceProperty: getters.priceAlertPropertyName}),
                levels: rootGetters.priceAlerts
            })
        })
    },

    getFormFieldValue: (state, getters) => ({path, idx}) => {
        const {isLine, isLandedCostLine, isCompany, isCustom, prop} = getFieldPathMeta(path)

        if (isLine || isLandedCostLine) {
            if (isCustom) {
                return _.get(getters.lines, [idx, 'custom', prop], null)
            } else {
                return _.get(getters.lines, [idx, prop], null)
            }
        } else if (isCompany) {
            if (isCustom) {
                return _.get(getters.company, ['custom', prop], null)
            } else {
                return _.get(getters.company, [prop], null)
            }
        } else {
            if (isCustom) {
                return _.get(getters.custom, prop, null)
            } else {
                return _.get(getters.doc, prop, null)
            }
        }
    },

    checkContractResponse: state => state.checkContractResponse || [],
    offContractLinesCount: (state, getters) => {
        return getters.checkContractResponse.filter(r =>
            (!r.on_contracts || r.on_contracts.length === 0) &&
            r.off_contracts && r.off_contracts.length !== 0
        ).length
    }
}

export const mutations = {
    [DOC_SET]: (state, doc) => {
        state.doc = _.cloneDeep(doc)
    },
    [DOC_SET_LINES]: (state, lines) => {
        state.lines = _.cloneDeep(lines)
    },
    [DOC_SET_NOTES]: (state, notes) => {
        state.notes = _.cloneDeep(notes)
    },
    [DOC_SET_TAGS]: (state, tags) => {
        state.tags = _.cloneDeep(tags)
    },
    [DOC_SET_ALLOCATIONS]: (state, allocations) => {
        allocations = allocations.map(a => ({...a, uuid: a.uuid || _.get(a, 'po.uuid')})) // TODO: remove this when backend is fixed (uuid is not returned for PO)
        state.allocations = _.cloneDeep(allocations)
    },
    [DOC_SET_USERS]: (state, users) => {
        state.users = _.cloneDeep(users)
    },
    [DOC_SET_COMPANY]: (state, company) => {
        state.company = _.cloneDeep(company)
    },
    [DOC_SET_CUSTOM_FIELDS]: (state, custom) => {
        state.custom = _.cloneDeep(custom)
    },
    [DOC_SET_APPROVAL]: (state, approval) => {
        state.approval = _.cloneDeep(approval)
    },

    [DOC_LINE_ADD]: (state, {idx, data}) => {
        Vue.set(state.lines, idx, data)
    },

    [DOC_NOTE_ADD]: (state) => {
        Vue.set(state.notes, state.notes.length, {body: ''})
    },
    [DOC_NOTE_UPDATE]: (state, {idx, data}) => {
        Vue.set(state.notes, idx, _.merge(state.notes[idx], data))
    },

    [DOC_SET_FIELD]: (state, {prop, data}) => {
        Vue.set(state.doc, prop, data)
    },
    [DOC_SET_COMPANY_FIELD]: (state, {prop, data}) => {
        if (!_.isPlainObject(state.company)) {
            state.company = {}
        }
        Vue.set(state.company, prop, data)

        if (state.company.supplier && data && prop === 'supplier') {
            Vue.set(state.company.supplier, 'paymentTerms', data.paymentTerms)
            if (state.company.supplier.paymentTerms && data.paymentTerms) {
                Vue.set(state.company.supplier.paymentTerms, 'purchase', data.paymentTerms.purchase)
                Vue.set(state.company.supplier.paymentTerms, 'sale', data.paymentTerms.sale)
            }
        } else if (prop === 'custom') {
            Vue.set(state.company, 'custom', data)
        }
    },
    [DOC_SET_CUSTOM_FIELD]: (state, {prop, data}) => {
        if (!_.isPlainObject(state.custom)) {
            state.custom = {}
        }
        Vue.set(state.custom, prop, data)
    },
    [DOC_SET_LINE_FIELD]: (state, {idx, prop, data}) => {
        Vue.set(state.lines[idx], prop, data)
    },

    [DOC_SET_IS_SAVING_CHANGES]: (state, flag) => {
        state.isSavingChanges = flag
    },

    [DOC_SET_RELATED_DOCUMENTS]: (state, {groups, docs}) => {
        state.relatedDocumentsInfo.docs = docs
        state.relatedDocumentsInfo.groups = groups
    },

    [DOC_CLEAR_RELATED_DOCUMENTS]: (state) => {
        state.relatedDocumentsInfo.docs = []
        state.relatedDocumentsInfo.groups = {}
    },

    /**
     * @param linesBatchUpdateData
     * Array<{
     *     idx: number, // line index
     *     path: string | Array, // line property path without `lines.` prefix
     *     data: any
     * }>
     */
    [DOC_LINES_BATCH_UPDATE]: (state, linesBatchUpdateData) => {
        if (!_.isArray(linesBatchUpdateData) || linesBatchUpdateData.length === 0) {
            return
        }
        for (const {idx, path, data} of linesBatchUpdateData) {
            Vue.set(state.lines, idx, _.set(_.cloneDeep(state.lines[idx]) || {}, path, data))
        }
    },

    [DOC_SET_CONTRACT_CHECK_RESPONSE]: (state, response) => {
        state.checkContractResponse = response
    }
}

export const actions = {
    [DOC_SET]: ({commit}, doc) => {
        const docWithoutNormalizedParts = _.omit(doc, [
            'company', 'lines', 'statementLines', 'notes', 'allocations',
            'users', 'custom', 'purchaseOrder', 'deliveryDocket'
        ])
        commit(DOC_SET, docWithoutNormalizedParts)

        // setup normalized parts:
        if (!_.isPlainObject(doc)) {
            doc = {}
        }
        commit(DOC_SET_COMPANY, doc.company)
        commit(DOC_SET_LINES, (doc.section === AppDocSystemTypes.STATEMENTS ? doc.statementLines : doc.lines) || [])
        commit(DOC_SET_NOTES, doc.notes || [])
        commit(DOC_SET_TAGS, doc.tags || [])
        commit(DOC_SET_ALLOCATIONS, doc.allocations || [])
        commit(DOC_SET_USERS, doc.users || [])
        commit(DOC_SET_CUSTOM_FIELDS, doc.custom || {})
        commit(`doc_viewer_po/${DOC_PO_SET}`, doc.purchaseOrder, {root: true})
        commit(`doc_viewer_supplier_receipt/${DOC_RECEIPT_SET}`, doc.deliveryDocket, {root: true})
    },
    [DOC_FIELD_UPDATE]: async({state, dispatch, commit, getters, rootGetters}, {
        path, // FormField.path
        idx, // for array type (like lines)
        data,
        merge = true,
        updateMetadata = true
    }) => {
        let {isCompany, isCustom, isLine, isLandedCostLine, prop} = getFieldPathMeta(path)
        let updatedProp = prop
        let mutation

        if (_.isObject(data)) {
            data = _.cloneDeep(data) // to avoid select options mutation while merge below
        }
        if (isLine || isLandedCostLine) { // LINES
            mutation = DOC_SET_LINE_FIELD
            if (isCustom) {
                updatedProp = 'custom'
                const customObj = getters.lines && getters.lines[idx].custom ? _.cloneDeep(getters.lines[idx].custom) : {}
                data = {...customObj, [prop]: data}
            }
        } else if (isCompany) { // COMPANY
            mutation = DOC_SET_COMPANY_FIELD
            if (isCustom) {
                updatedProp = 'custom'
                if (merge && _.isObject(data) && _.isObject(getters.company.custom[prop])) {
                    data = _.merge(getters.company.custom[prop], data)
                }
            } else {
                if (merge && _.isObject(data) && _.isObject(getters.company[prop])) {
                    data = _.merge(getters.company[prop], data)
                }
            }
        } else { // ROOT
            if (isCustom) {
                mutation = DOC_SET_CUSTOM_FIELD
                if (merge && _.isObject(data) && _.isObject(getters.custom[prop])) {
                    data = _.merge(getters.custom[prop], data)
                }
            } else {
                mutation = DOC_SET_FIELD
                if (merge && _.isObject(data) && _.isObject(getters.doc[prop])) {
                    data = _.merge(getters.doc[prop], data)
                }
            }
        }
        commit(mutation, {prop: updatedProp, idx, data})

        if (updateMetadata) {
            await dispatch(`doc_viewer_metadata/${DOC_METADATA_TOUCH_FIELD}`, {path, idx}, {root: true})
        }
    },

    [DOC_LINES_BATCH_UPDATE]: async({commit}, linesBatchUpdateData) => {
        commit(DOC_LINES_BATCH_UPDATE, linesBatchUpdateData)
    },
    [DOC_CLEAR_DEPENDENT_FIELD_VALUES]: async({dispatch, getters, commit, rootGetters}, {path, idx}) => {
        const dependentFields = rootGetters['doc_viewer_settings/fields'].filter(f => {
            if (!f.dependants || f.dependants.length === 0) {
                return false
            }
            return f.dependants.some(d => d.path === path)
        })
        if (dependentFields.length === 0) {
            return
        }
        const {isLine, isLandedCostLine} = getFieldPathMeta(path)
        const isRootFieldChanged = !isLine && !isLandedCostLine
        const dependentFieldsWithValue = [] // {field, idx}

        dependentFields.forEach(field => {
            const {isLine, isLandedCostLine, isCompany} = getFieldPathMeta(field.path)
            const isLineFieldDependent = isLine || isLandedCostLine

            if (isRootFieldChanged && isLineFieldDependent) {
                getters.lines.forEach((_, idx) => {
                    if (getters.getFormFieldValue({path: field.path, idx})) {
                        dependentFieldsWithValue.push({field, idx})
                    }
                })
            } else if (getters.getFormFieldValue({path: field.path, idx})) {
                dependentFieldsWithValue.push({field, idx})
            }
        })
        if (dependentFieldsWithValue.length === 0) {
            return
        }

        for (const {field, idx} of dependentFieldsWithValue) {
            await dispatch(DOC_FIELD_UPDATE, {path: field.path, idx, data: null})
            if (field.path === 'company.name') {
                await commit(DOC_SET_COMPANY, null)
            } else if (field.path === 'lines.sku') {
                await dispatch(DOC_LINE_CLEAR_SKU_AND_DETACH_ITEM, idx)
            }
        }

        const clearedFieldLabels = dependentFieldsWithValue.map(getDependentFieldLabel).join(', ')

        showSuccessMessage('Dependent fields cleared', {
            caption: `<small>The following fields were cleared because they depend on the field you've just changed:</small>
                      <div class="text-bold">${clearedFieldLabels}</div>`,
            withClose: true
        })
    },

    [DOC_SAVE_CHANGES]: async({dispatch, getters, rootGetters, commit}) => {
        if (!rootGetters['doc_viewer_access_level/canEditDoc']) {
            showInfoMessage('Unable to save', {caption: 'You don\'t have permission to edit this document'})
            return
        } else if (getters.disabledDocument) {
            showInfoMessage('Unable to save', {caption: 'The document is in read-only status'})
            return
        }
        commit(DOC_SET_IS_SAVING_CHANGES, true)
        await dispatch(DOC_ADJUST_DATA_FOR_API)
        let error, data, _axios
        if (rootGetters['documents/isDemoContracts']) {
            ({error, data, _axios} = await demoContractApi.createOrUpdate(getters.docWithNormalizedParts))
        } else {
            ({error, data, _axios} = await documentApi.update({
                doc: getters.docWithNormalizedParts,
                requestId: DOC_SAVE_CHANGES
            }))
        }
        if (error) {
            if (!axios.isCancel(_axios.error)) {
                Raven.captureException(error)
                showErrorMessage('Unable to save changes, please try again later')
            }
            commit(DOC_SET_IS_SAVING_CHANGES, false)
        } else {
            await dispatch(DOC_SET, data)
            showSuccessMessage('Changes saved', {
                withClose: true,
                duration: 2500
            })
            Vue.prototype.$nextTick(() => {
                commit(DOC_SET_IS_SAVING_CHANGES, false)
            })
        }
    },

    // Use before saving / processing the document
    [DOC_ADJUST_DATA_FOR_API]: async({dispatch, rootGetters}) => {
        await dispatch(DOC_REMOVE_EMPTY_LINES)

        // Clear matched items if document type changed and the corresponding extension is not enabled
        if (!rootGetters['doc_viewer_settings/poCheckEnabled'] &&
            rootGetters['doc_viewer_po/purchaseOrder']) {
            await dispatch(`doc_viewer_po/${DOC_PO_ON_UNMATCH}`, null, {root: true})
        }
        if (!rootGetters['doc_viewer_settings/supplierReceiptsCheckEnabled'] &&
            rootGetters['doc_viewer_supplier_receipt/deliveryDocket']) {
            await dispatch(`doc_viewer_supplier_receipt/${DOC_RECEIPT_ON_UNMATCH}`, null, {root: true})
        }
    },

    [DOC_ADD_HIDDEN_FIELDS_INTO_MODEL]: async({getters, dispatch, rootGetters}) => {
        const hiddenFields = rootGetters['doc_viewer_settings/fields'].filter(f => !f.visible)

        for (const {editor, path} of hiddenFields) {
            let {isLine, isLandedCostLine, prop} = getFieldPathMeta(path)
            if (isLine || isLandedCostLine) {
                const linesBatchUpdateData = []
                getters.lines.forEach((line, idx) => {
                    const value = getters.getFormFieldValue({path, idx})
                    linesBatchUpdateData.push({
                        path: prop,
                        idx,
                        data: value !== 'undefined' && value !== null ? value : editor.default
                    })
                })
                if (linesBatchUpdateData.length !== 0) {
                    await dispatch(DOC_LINES_BATCH_UPDATE, linesBatchUpdateData)
                }
            } else {
                const value = getters.getFormFieldValue({path})
                await dispatch(DOC_FIELD_UPDATE, {
                    path,
                    data: value !== 'undefined' && value !== null ? value : editor.default
                })
            }
        }
    },

    // Necessary for merging lines into common items section
    // if there is no section for landed cost items
    // (use on settings change).
    [DOC_ADJUST_LINES_TYPE]: async({getters, rootGetters, dispatch}) => {
        const formHasLandedCostLines = rootGetters['doc_viewer_settings/sections']
            .some(s => s.key === FormSystemSections.LANDED_COST_LINES && s.visible)

        const linesBatchUpdateData = []
        getters.lines.forEach((line, idx) => {
            if (!line.original_type) {
                linesBatchUpdateData.push({idx, path: 'original_type', data: line.type})
            }
            if (formHasLandedCostLines) {
                if (line.type === AppDocLineTypes.ITEM &&
                    line.original_type === AppDocLineTypes.LANDED_COST) {
                    // move line to landed cost items section
                    linesBatchUpdateData.push({idx, path: 'type', data: AppDocLineTypes.LANDED_COST})
                }
            } else {
                if (line.type === AppDocLineTypes.LANDED_COST) {
                    // move line to items section
                    linesBatchUpdateData.push({idx, path: 'type', data: AppDocLineTypes.ITEM})
                }
            }
        })
        if (linesBatchUpdateData.length !== 0) {
            await dispatch(DOC_LINES_BATCH_UPDATE, linesBatchUpdateData)
        }
    },

    [DOC_LINE_ADD]: async({dispatch, commit, getters, rootGetters}, {isLandedCost, duplicateFromLineIdx}) => {
        let newLine
        if (_.isNumber(duplicateFromLineIdx) && getters.lines[duplicateFromLineIdx]) {
            newLine = _.cloneDeep(getters.lines[duplicateFromLineIdx])
            delete newLine.uuid
            delete newLine.original_type
        } else {
            newLine = {}
            const lastLine = _.last(getters.notDeletedLines
                .filter(l => l.type === (isLandedCost ? AppDocLineTypes.LANDED_COST : AppDocLineTypes.ITEM))
            )
            if (_.isPlainObject(lastLine)) {
                for (const field of rootGetters['doc_viewer_settings/visibleFields']) {
                    let {isLine, isLandedCostLine, isCustom, prop} = getFieldPathMeta(field.path)
                    if ((isLandedCost ? !isLandedCostLine : !isLine) ||
                        !field.editor ||
                        ![FieldEditorTypes.DD_SINGLE, FieldEditorTypes.DD_MULTIPLE].includes(field.editor.type)) {
                        continue
                    }
                    if (isCustom) {
                        if (!_.isPlainObject(newLine.custom)) {
                            newLine.custom = {}
                        }
                        try {
                            newLine.custom[prop] = _.cloneDeep(lastLine.custom[prop])
                        } catch (ex) {
                            newLine.custom[prop] = null
                        }
                    } else {
                        newLine[prop] = _.cloneDeep(lastLine[prop])
                    }
                }
            }
        }

        if (!getters.isStatements) {
            newLine.type = isLandedCost ? AppDocLineTypes.LANDED_COST : AppDocLineTypes.ITEM
        }
        // can be set in doc-viewer (higher priority than from supplier data)
        if (newLine.hasOwnProperty('location') && getters.docUniqueLocations.length === 1) {
            newLine.location = getters.docUniqueLocations[0]
        }
        // can be set in doc-viewer
        if (newLine.hasOwnProperty('subsidiary') && getters.docUniqueSubsidiaries.length === 1) {
            newLine.subsidiary = getters.docUniqueSubsidiaries[0]
        }

        if (getters.matchingSupplier) {
            const sp = getters.matchingSupplier
            const allowReplacementWithSupplierData = field => newLine.hasOwnProperty(field) && !newLine[field] && sp[field]
            if (allowReplacementWithSupplierData('location')) {
                newLine.location = sp.location
            }
            if (allowReplacementWithSupplierData('subsidiary')) {
                newLine.subsidiary = sp.subsidiary
            }
            if (allowReplacementWithSupplierData('glAccount')) {
                newLine.glAccount = sp.glAccount
            }
            if (allowReplacementWithSupplierData('taxType')) {
                newLine.taxType = sp.taxType
            }
            if (allowReplacementWithSupplierData('taxTreatment')) {
                newLine.taxTreatment = sp.taxTreatment
            }
            if (allowReplacementWithSupplierData('department')) {
                newLine.department = sp.department
            }
            if (allowReplacementWithSupplierData('costCentre')) {
                newLine.costCentre = sp.costCentre
            }
            if (allowReplacementWithSupplierData('project')) {
                newLine.project = sp.project
            }
            if (allowReplacementWithSupplierData('currency')) {
                newLine.currency = sp.currency
            }
        }
        const idx = getters.lines.length
        commit(DOC_LINE_ADD, {idx, data: newLine})
        await dispatch(`doc_viewer_metadata/${DOC_METADATA_GENERATE_FOR_LINE}`, {idx}, {root: true})

        let pathMeta
        // pre-validate each line field metadata
        for (const {idx: idx1, path} of rootGetters['doc_viewer_metadata/formMetadata']) {
            pathMeta = getFieldPathMeta(path)
            if ((pathMeta.isLine || pathMeta.isLandedCostLine) && idx1 === idx) {
                await dispatch(`doc_viewer_metadata/${DOC_METADATA_TOUCH_FIELD}`, {path, idx}, {root: true})
            }
        }
    },

    [DOC_LINE_REMOVE]: async({dispatch, commit, getters, rootGetters}, {idx}) => {
        await dispatch(DOC_FIELD_UPDATE, {path: 'lines.isDeleted', idx, data: true})
        await dispatch(`doc_viewer_metadata/${DOC_METADATA_REMOVE_FOR_LINE}`, {idx}, {root: true})
        await dispatch(`doc_viewer_metadata/${DOC_METADATA_BUILD_ERRORS_LIST}`, null, {root: true})
    },

    [DOC_REMOVE_EMPTY_LINES]: ({dispatch, getters}) => {
        getters.lines.forEach((line, idx) => {
            if (Object.values(line).every(x => (x === null || x === ''))) { // empty line
                dispatch(DOC_LINE_REMOVE, {idx})
            }
        })
    },

    [DOC_SET_STATUS]: async({getters, dispatch}, {status, callback}) => {
        const invalidStatus = !status || !status.key || getters.status.key === status.key
        if (invalidStatus) {
            return
        }
        const readOnlyStatus = [AppDocSystemStatusGroups.SCANNING, AppDocSystemStatusGroups.APPROVE].includes(status.key)
        if (readOnlyStatus) {
            showInfoMessage('Unable to change readonly status')
        }
        const statusKey = status.key
        if (getters.isSystemDoc && statusKey === AppDocSystemStatuses.REJECT) {
            return Vue.prototype.$modal.show('reject-document', {
                doc: getters.docWithNormalizedParts,
                onReject: async() => {
                    await dispatch(DOC_FIELD_UPDATE, {path: 'status', data: statusKey})
                    if (callback) {
                        callback()
                    }
                }
            })
        }
        const {error, _axios} = await documentApi.setStatus({id: getters.doc.uuid, status: statusKey})
        if (error) {
            const isDuplicate = _.get(_axios, 'response.status') === 409
            if (isDuplicate) {
                dispatch(DOC_FIELD_UPDATE, {path: 'hasDuplicate', data: true})
                EventBus.$emit('RESOLVE_DUPLICATE')
            } else {
                showErrorMessage('Unable to change status')
            }
        } else {
            await dispatch(DOC_FIELD_UPDATE, {path: 'status', data: statusKey})
        }
    },

    [DOC_SET_LOCATION]: async({getters, dispatch}, location) => {
        if (getters.isSystemDoc) {
            getters.lines.forEach((line, idx) => {
                dispatch(DOC_FIELD_UPDATE, {path: 'lines.location', data: location, idx})
            })
        } else {
            axios.post(`documents/types/${getters.dt.uuid}/documents/location`, {
                uuid: getters.doc.uuid,
                location: location ? location.uuid : null
            })
                .then(() => {
                    const data = [location]
                    dispatch(DOC_FIELD_UPDATE, {path: 'locations', data})
                })
                .catch(() => {
                    showErrorMessage('Unable to change location')
                })
        }
    },

    [DOC_SET_SUBSIDIARY]: async({getters, dispatch}, subsidiary) => {
        if (getters.isSystemDoc) {
            getters.lines.forEach((line, idx) => {
                dispatch(DOC_FIELD_UPDATE, {path: 'lines.subsidiary', data: subsidiary, idx})
            })
        } else {
            axios.post(`documents/types/${getters.dt.uuid}/documents/subsidiary`, {
                uuid: getters.doc.uuid,
                subsidiary: subsidiary ? subsidiary.uuid : null
            })
                .then(() => {
                    const data = [subsidiary]
                    dispatch(DOC_FIELD_UPDATE, {path: 'subsidiaries', data})
                })
                .catch(() => {
                    showErrorMessage('Unable to change subsidiary')
                })
        }
    },

    [DOC_LINE_ALTERNATIVE_ALERT]: ({getters, rootGetters}, {lineIdx, internalCode, externalCode}) => {
        if (rootGetters['doc_viewer_settings/noItemAlternativeAlert']) {
            return
        }
        Vue.prototype.$modal.show('create-update-alternative', {
            operation: getters.lines[lineIdx].isAlternative ? 'update' : 'create',
            supplierUuid: getters.matchingSupplier ? getters.matchingSupplier.uuid : null,
            invoiceUuid: getters.doc.uuid,
            lineIdx,
            internalCode,
            externalCode
        })
    },

    [DOC_LINE_CLEAR_SKU_AND_DETACH_ITEM]: async({dispatch, getters}, idx) => {
        await Promise.all([
            dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.sku', data: null, updateMetadata: true}),
            dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.product', data: null, updateMetadata: false}),
            dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.item_uuid', data: null, updateMetadata: false}),
            dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.isAlternative', data: false, updateMetadata: false}),
            dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.original_sku', data: null, updateMetadata: false})
        ])
    },

    [DOC_LINE_ON_CHANGE_SKU]: async({getters, dispatch, commit, rootGetters}, {sku, idx}) => {
        const line = getters.lines[idx]
        if (line && line.product && line.product.sku === sku) {
            return
        }
        try {
            const skuDependencies = getFieldDependencyQueryParams({
                field: rootGetters['doc_viewer_settings/getFieldSettingsByPath']('lines.sku'),
                docData: getters.docWithNormalizedParts,
                lineIdx: idx
            })
            const res = await axios.get('items', {
                params: {
                    q: sku,
                    page: 1,
                    invoiceUUID: getters.doc.uuid,
                    dependencies: skuDependencies
                },
                contact_uuid: getters.matchingSupplier ? getters.matchingSupplier.uuid : null,
                requestId: `CHECK-SKU-${idx}`
            })
            const items = res.data.data || []
            const item = items.find(el => el.sku === sku)

            await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.product', data: item, updateMetadata: false})
            await dispatch(DOC_FIELD_UPDATE, {
                idx,
                path: 'lines.item_uuid',
                data: item && item.uuid ? item.uuid : null,
                updateMetadata: false
            })

            if (line.original_sku && sku && line.original_sku !== sku) {
                await dispatch(DOC_LINE_ALTERNATIVE_ALERT, {
                    lineIdx: idx,
                    externalCode: line.original_sku,
                    internalCode: sku
                })
            }

            if (item) {
                const extension = rootGetters['doc_viewer_settings/matchItemExtension']
                const overrideEnabled = !!_.get(extension, ['params', 'override', 'enabled'])
                const overrideForce = !!_.get(extension, ['params', 'override', 'force'])
                const overrideWithConfirmation = !!_.get(extension, ['params', 'override', 'confirm'])

                if (overrideEnabled) {
                    if (overrideWithConfirmation) {
                        Vue.$snotify.confirm(
                            'Update line with matched item data?',
                            'Update data', {
                                timeout: 10000,
                                showProgressBar: true,
                                closeOnClick: false,
                                buttons: [{
                                    text: 'Yes',
                                    action: async toast => {
                                        await dispatch(DOC_LINE_OVERRIDE_DATA_FOR_SELECTED_ITEM, {
                                            idx,
                                            item,
                                            force: overrideForce
                                        })
                                        Vue.$snotify.remove(toast.id)
                                    }
                                }, {text: 'No', action: toast => Vue.$snotify.remove(toast.id)}]
                            })
                    } else {
                        await dispatch(DOC_LINE_OVERRIDE_DATA_FOR_SELECTED_ITEM, {idx, item, force: overrideForce})
                    }
                }
            }

            dispatch(`doc_viewer_metadata/${DOC_METADATA_TOUCH_FIELD}`, {path: 'lines.sku', idx}, {root: true})

            if (rootGetters['doc_viewer_settings/withLineUomConversion']) {
                const supplierId = _.get(getters.matchingSupplier, 'uuid')
                const conversionList = _.get(item, 'itemUomConversions') || []
                const conversionsForThisSupplier = conversionList.filter(c => _.get(c, 'supplier.uuid') === supplierId)
                const conversion = conversionsForThisSupplier.length === 1 && conversionsForThisSupplier[0].uom
                    ? conversionsForThisSupplier[0]
                    : null
                const uom = conversion ? conversion.uom : null
                await dispatch(DOC_FIELD_UPDATE, {path: 'lines.unit_of_measure', idx, data: uom})

                if (item && item.uom) {
                    await dispatch(DOC_FIELD_UPDATE, {path: 'lines.uom_conversion', idx, data: item.uom})
                }
                await dispatch(DOC_LINE_UOM_CALCULATE_CONVERTED_QTY, {idx, item})

                const price = conversion && conversion.price ? conversion.price : item.price
                if (price) {
                    await dispatch(DOC_FIELD_UPDATE, {path: 'lines.price', idx, data: price})
                    await dispatch(DOC_LINE_UOM_CALCULATE_BASE_PRICE, {idx, item})
                }
            }
        } catch (e) {
            if (!axios.isCancel(e)) {
                Raven.captureException(e)
            }
        }
    },

    [DOC_LINE_OVERRIDE_DATA_FOR_SELECTED_ITEM]: async({getters, dispatch, commit, rootGetters}, {
        idx,
        item,
        force
    }) => {
        const line = getters.lines[idx]
        if (!line || !item || !item.uuid) {
            return
        }
        const overrideQty = item.qty && (force || !line.qty)
        const overridePrice = item.price && (force || !line.price)
        const overrideDescription = item.description && (force || !line.description)

        const isVisibleSupplierField = rootGetters['doc_viewer_settings/checkIsVisibleFieldByPath']('lines.supplier')
        const overrideSupplier = isVisibleSupplierField
            ? (item.supplier && (force || !line.supplier))
            : false

        if (overrideDescription) {
            await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.description', data: item.description})
        }
        if (overrideSupplier) {
            await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.supplier', data: item.supplier})
        }

        let lastModifiedPricingFormField
        if (overrideQty) {
            await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.qty', data: item.qty ? item.qty : 1})
            lastModifiedPricingFormField = 'qty'
        }
        if (overridePrice) {
            await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.price', data: item.price})
            lastModifiedPricingFormField = 'price'
        }
        if (lastModifiedPricingFormField && rootGetters['doc_viewer_settings/calculateLineTotal']) {
            dispatch(DOC_RECALCULATE_LINE_TOTAL, {idx, emittedByProp: lastModifiedPricingFormField})
        }

        return axios.get(`items/${item.uuid}`)
            .then(async res => {
                const data = res.data.data
                if (!data || !data.uuid) {
                    return
                }

                const overrideAccount = data.glAccount && (force || !line.glAccount)
                const overrideSalesAccount = data.revenueAccount && (force || !line.glAccount)
                const overrideTaxType = data.taxType && (force || !line.taxType)
                const overrideSalesTaxType = data.salesTaxType && (force || !line.taxType)
                const overrideUOM = data.uom && (force || !line.unit_of_measure)
                const overrideDepartment = data.department && (force || !line.department)
                const overrideCostCenter = data.costCentre && (force || !line.costCentre)

                if (getters.isPurchases && overrideAccount) {
                    await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.glAccount', data: data.glAccount})
                } else if (getters.isSales && overrideSalesAccount) {
                    await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.glAccount', data: data.revenueAccount})
                }

                if (getters.isPurchases && overrideTaxType) {
                    await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.taxType', data: data.taxType})
                } else if (getters.isSales && overrideSalesTaxType) {
                    await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.taxType', data: data.salesTaxType})
                }

                if (overrideUOM) {
                    await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.unit_of_measure', data: data.uom})
                }
                if (overrideDepartment) {
                    await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.department', data: data.department})
                }
                if (overrideCostCenter) {
                    await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.costCentre', data: data.costCentre})
                }

                if (_.isPlainObject(data.custom)) {
                    for (const customProp in data.custom) {
                        dispatch(DOC_FIELD_UPDATE, {
                            path: `lines.custom.${customProp}`,
                            idx,
                            data: data.custom[customProp]
                        })
                    }
                }
            })
    },

    [DOC_LINE_UOM_CALCULATE_CONVERTED_QTY]: async({getters, dispatch, commit, rootGetters}, {idx, item}) => {
        const line = getters.lines[idx]
        const fromUomId = _.get(line, 'unit_of_measure.uuid')
        const conversion = await dispatch(DOC_LINE_UOM_FIND_CONVERSION, {item, uomId: fromUomId})

        let qtyConverted = 0
        if (conversion.operation === ProductUomConversionOperatorTypes.MULTIPLY) {
            qtyConverted = forceToNumber(line.qty) * forceToNumber(conversion.factor)
        } else if (conversion.operation === ProductUomConversionOperatorTypes.DIVIDE) {
            qtyConverted = forceToNumber(line.qty) / forceToNumber(conversion.factor)
        }
        const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('lines.qty')
        qtyConverted = round(qtyConverted, precision)
        if (qtyConverted && line.qtyConverted !== qtyConverted) {
            await dispatch(DOC_FIELD_UPDATE, {path: 'lines.qtyConverted', idx, data: qtyConverted})
        }
    },

    [DOC_LINE_UOM_CALCULATE_PRICE]: async({getters, dispatch, commit, rootGetters}, {idx, item}) => {
        const line = getters.lines[idx]
        const fromUomId = _.get(line, 'unit_of_measure.uuid')
        const conversion = await dispatch(DOC_LINE_UOM_FIND_CONVERSION, {item, uomId: fromUomId})

        let price = 0
        if (conversion.operation === ProductUomConversionOperatorTypes.MULTIPLY) {
            price = forceToNumber(line.basePrice) * forceToNumber(conversion.factor)
        } else if (conversion.operation === ProductUomConversionOperatorTypes.DIVIDE) {
            price = forceToNumber(line.basePrice) / forceToNumber(conversion.factor)
        }
        const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('lines.price')
        price = round(price, precision)
        if (price && line.price !== price) {
            await dispatch(DOC_FIELD_UPDATE, {path: 'lines.price', idx, data: price})
        }
    },

    [DOC_LINE_UOM_CALCULATE_BASE_PRICE]: async({getters, dispatch, commit, rootGetters}, {idx, item}) => {
        const line = getters.lines[idx]
        const fromUomId = _.get(line, 'unit_of_measure.uuid')
        const conversion = await dispatch(DOC_LINE_UOM_FIND_CONVERSION, {item, uomId: fromUomId})

        let basePrice = 0
        if (conversion.operation === ProductUomConversionOperatorTypes.MULTIPLY) {
            basePrice = forceToNumber(line.price) / forceToNumber(conversion.factor)
        } else if (conversion.operation === ProductUomConversionOperatorTypes.DIVIDE) {
            basePrice = forceToNumber(line.price) * forceToNumber(conversion.factor)
        }
        const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('lines.price')
        basePrice = round(basePrice, precision)
        if (basePrice && line.basePrice !== basePrice) {
            await dispatch(DOC_FIELD_UPDATE, {path: 'lines.basePrice', idx, data: basePrice})
        }
    },

    [DOC_LINE_UOM_SET_PRICE_FROM_ITEM_CONVERSION_TABLE]: async({getters, dispatch, commit, rootGetters}, {
        idx,
        item
    }) => {
        const line = getters.lines[idx]
        const fromUomId = _.get(line, 'unit_of_measure.uuid')
        const conversion = await dispatch(DOC_LINE_UOM_FIND_CONVERSION, {item, uomId: fromUomId})

        const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('lines.price')
        const price = round(forceToNumber(conversion.price), precision)
        if (price && line.price !== price) {
            await dispatch(DOC_FIELD_UPDATE, {path: 'lines.price', idx, data: price})
        }
    },

    [DOC_LINE_UOM_FIND_CONVERSION]: async({getters, dispatch, commit, rootGetters}, {item, uomId}) => {
        const supplierId = _.get(getters.matchingSupplier, 'uuid')
        const defaultConversion = {
            factor: 1,
            operation: ProductUomConversionOperatorTypes.MULTIPLY
        }
        const conversions = (_.get(item, 'itemUomConversions') || [])
            .filter(c => c.uom && c.uom.uuid && c.operation && c.factor)

        let conversion
        if (supplierId) { // first attempt - try to find supplier-specific conversion
            conversion = conversions.find(c => c.uom.uuid === uomId && _.get(c, 'supplier.uuid') === supplierId)
        }
        if (!conversion) { // second attempt - try to find any conversion for line UOM
            conversion = conversions.find(c => c.uom.uuid === uomId)
        }
        return conversion || defaultConversion
    },

    [DOC_CLEAN_SUPPLIER]: ({commit}) => {
        commit(DOC_SET_COMPANY_FIELD, {prop: 'supplier', data: null, updateMetadata: false})
        commit(DOC_SET_COMPANY_FIELD, {prop: 'supplier_uuid', data: null, updateMetadata: false})
        commit(DOC_SET_COMPANY_FIELD, {prop: 'create', data: true, updateMetadata: false})
    },

    [DOC_FILL_SUPPLIER]: async({getters, dispatch, commit, rootGetters}, uuid) => {
        if (getters.disabledDocument) {
            return
        }
        if (!uuid) {
            dispatch(DOC_CLEAN_SUPPLIER)
            return
        }

        const data = await axios.get(`suppliers/${uuid}`).then(res => res.data.data || {})
        if (!data || !data.uuid) {
            dispatch(DOC_CLEAN_SUPPLIER)
            return
        }
        commit(DOC_SET_COMPANY_FIELD, {prop: 'supplier', data, updateMetadata: false})
        commit(DOC_SET_COMPANY_FIELD, {prop: 'supplier_uuid', data: data.uuid, updateMetadata: false})
        commit(DOC_SET_COMPANY_FIELD, {prop: 'create', data: false, updateMetadata: false})
        if (data.currency && data.currency.code) {
            dispatch(DOC_FIELD_UPDATE, {path: 'currency', data: data.currency})
        }

        const extension = rootGetters['doc_viewer_settings/contactSelectExtension']

        const overrideContact = _.get(extension, 'params.override.contact') || {}
        const overrideLines = _.get(extension, 'params.override.lines') || {}

        const updateContactSection = (data = {}, force = false) => {
            const companyData = {}
            const companyPhone = _.isArray(data.phones)
                ? _.get(data.phones.find(el => el && !!el.number), 'number')
                : null
            const companyEmail = _.isArray(data.emails)
                ? _.get(data.emails.find(el => el && !!el.email), 'email')
                : null

            const overrideName = data.name && (force || !getters.company.name)
            const overrideTax = data.tax && (force || !getters.company.tax)
            const overrideCode = data.code && (force || !getters.company.code)
            const overridePhone = companyPhone && (force || !getters.company.phone)
            const overrideEmail = companyEmail && (force || !getters.company.email)

            if (overrideName) {
                companyData.name = data.name
            }
            if (overrideTax) {
                companyData.tax = data.tax
            }
            if (overrideCode) {
                companyData.code = data.code
            }
            if (overridePhone) {
                companyData.phone = companyPhone
            }
            if (overrideEmail) {
                companyData.email = companyEmail
            }
            commit(DOC_SET_COMPANY, _.merge(getters.company, companyData))
        }

        const updateLinesSection = async(data = {}, force = false) => {
            try {
                const linesBatchUpdateData = []
                for (const prop in data) {
                    const value = data[prop]
                    for (const line of getters.lines) {
                        const isHiddenField = !rootGetters['doc_viewer_settings/checkIsVisibleFieldByPath'](`lines.${prop}`)
                        if (!value || isHiddenField) {
                            continue
                        }
                        const overrideProp = value && (force || !line[prop])
                        if (!overrideProp) {
                            continue
                        }
                        linesBatchUpdateData.push({
                            path: prop,
                            data: value,
                            idx: getters.lines.indexOf(line)
                        })
                    }
                }
                if (linesBatchUpdateData.length !== 0) {
                    await dispatch(DOC_LINES_BATCH_UPDATE, linesBatchUpdateData)
                }
            } catch (e) {
                Raven.captureException(e)
            }
        }

        if (overrideContact.enabled) {
            if (overrideContact.confirm) {
                Vue.$snotify.confirm(
                    `Update ${$lang.contact.singular} section from selected ${$lang.supplier.singular} data`,
                    `Update ${$lang.contact.singular}`, {
                        timeout: 10000,
                        showProgressBar: true,
                        closeOnClick: false,
                        buttons: [{
                            text: 'Yes',
                            action: toast => {
                                updateContactSection(data, overrideContact.force)
                                Vue.$snotify.remove(toast.id)
                            }
                        }, {text: 'No', action: toast => Vue.$snotify.remove(toast.id)}]
                    })
            } else {
                updateContactSection(data, overrideContact.force)
            }
        }

        if (overrideLines.enabled) {
            if (overrideLines.confirm) {
                Vue.$snotify.confirm(
                    `Update ${$lang.item.plural} section from selected ${$lang.supplier.singular} data`,
                    `Update ${$lang.item.plural}`, {
                        timeout: 10000,
                        showProgressBar: true,
                        closeOnClick: false,
                        buttons: [{
                            text: 'Yes',
                            action: async toast => {
                                await updateLinesSection(data, overrideLines.force)
                                Vue.$snotify.remove(toast.id)
                            }
                        }, {text: 'No', action: toast => Vue.$snotify.remove(toast.id)}]
                    })
            } else {
                await updateLinesSection(data, overrideLines.force)
            }
        }
    },

    [DOC_FILL_ADDRESS]: ({dispatch, getters, rootGetters}, address) => {
        if (getters.disabledDocument) {
            return
        }
        if (address.deliverTo) {
            dispatch(DOC_FIELD_UPDATE, {path: 'deliverTo', data: address.deliverTo})
        }
        if (address.attnTo) {
            dispatch(DOC_FIELD_UPDATE, {path: 'deliverAttn', data: address.attnTo})
        }
        if (address.address) {
            dispatch(DOC_FIELD_UPDATE, {path: 'deliverLine1', data: address.address})
        }
        if (address.address2) {
            dispatch(DOC_FIELD_UPDATE, {path: 'deliverLine2', data: address.address2})
        }
        if (address.city) {
            dispatch(DOC_FIELD_UPDATE, {path: 'deliverCity', data: address.city})
        }
        if (address.postal_code) {
            dispatch(DOC_FIELD_UPDATE, {path: 'deliverPostCode', data: address.postal_code})
        }
        if (address.state) {
            const settings = rootGetters['doc_viewer_settings/getFieldSettingsByPath']('custom.deliverState')
            if (settings && // LiveBetter custom case
                settings.editor &&
                settings.editor.type === FieldEditorTypes.DD_SINGLE &&
                settings.editor.select &&
                settings.editor.select.trackBy &&
                _.isArray(settings.editor.select.options)) {
                const state = settings.editor.select.options.find(o => o && o[settings.editor.select.trackBy] === address.region)
                if (state) {
                    dispatch(DOC_FIELD_UPDATE, {path: 'custom.deliverState', data: state})
                }
            } else {
                dispatch(DOC_FIELD_UPDATE, {path: 'deliverState', data: address.state})
            }
        }
        if (address.country) {
            const settings = rootGetters['doc_viewer_settings/getFieldSettingsByPath']('custom.deliverCountry')
            if (settings && // LiveBetter custom case
                settings.editor &&
                settings.editor.type === FieldEditorTypes.DD_SINGLE &&
                settings.editor.select &&
                settings.editor.select.trackBy &&
                _.isArray(settings.editor.select.options)) {
                const country = settings.editor.select.options.find(o => o && o[settings.editor.select.trackBy] === address.country)
                if (country) {
                    dispatch(DOC_FIELD_UPDATE, {path: 'custom.deliverCountry', data: country})
                }
            } else {
                dispatch(DOC_FIELD_UPDATE, {path: 'deliverCountry', data: address.country})
            }
        }
    },

    [DOC_RECALCULATE_TOTAL]: async({dispatch, getters, rootGetters}) => {
        if (getters.disabledDocument) {
            return
        }
        const extension = rootGetters['doc_viewer_settings/calculateDocTotalExtension']
        if (!extension) {
            return
        }
        let formulaKey = DocTotalCalculationFormulas.TOTAL_EQUAL_LINES_TOTAL_SUM
        if (extension.params && extension.params.formulaKey) {
            formulaKey = extension.params.formulaKey
        }

        let total
        if (formulaKey === DocTotalCalculationFormulas.TOTAL_EQUAL_LINES_TOTAL_SUM) {
            if (!getters.lines) {
                return
            }
            const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('total')
            total = round(getters.linesTotalsSum, precision)
            await dispatch(DOC_FIELD_UPDATE, {path: 'total', data: total})
        } else if ([
            DocTotalCalculationFormulas.TOTAL_EQUAL_TO_SUBTOTAL_CONSIDERED_WITH_TAX_TREATMENT,
            DocTotalCalculationFormulas.TOTAL_EQUAL_TO_SUBTOTAL_AND_DISCOUNT_CONSIDERED_WITH_TAX_TREATMENT
        ].includes(formulaKey)) {
            let {subtotal, tax, discount} = getDocTotalValues(getters.doc)
            tax = getters.docTaxTreatmentCode === TaxTreatmentCodes.EXCLUSIVE ? tax : 0
            const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('total')
            total = round(subtotal + tax, precision)
            if (formulaKey === DocTotalCalculationFormulas.TOTAL_EQUAL_TO_SUBTOTAL_AND_DISCOUNT_CONSIDERED_WITH_TAX_TREATMENT) {
                total -= discount
            }
            await dispatch(DOC_FIELD_UPDATE, {path: 'total', data: total})
        }
    },

    [DOC_RECALCULATE_SUBTOTAL]: async({dispatch, getters, rootGetters}) => {
        if (getters.disabledDocument || !getters.lines) {
            return
        }
        const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('subtotal')
        await dispatch(DOC_FIELD_UPDATE, {
            path: 'subtotal',
            data: round(getters.linesTotalsSum, precision)
        })
    },

    [DOC_RECALCULATE_TAX]: async({dispatch, getters, rootGetters}) => {
        if (getters.disabledDocument || !getters.lines || !rootGetters['doc_viewer_settings/calculateDocTaxAndOverride']) {
            return
        }
        const tax = getters.linesTaxSumForSelectedCalculationFormula
        const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('tax')
        if (tax !== getters.doc.tax) {
            await dispatch(DOC_FIELD_UPDATE, {
                path: 'tax',
                data: round(tax, precision)
            })
        }
    },

    [DOC_RECALCULATE_FREIGHT]: async({dispatch, getters, rootGetters}) => {
        if (getters.disabledDocument || !getters.lines) {
            return
        }
        const freight = getters.notDeletedLines
            .filter(l => l.type === AppDocLineTypes.LANDED_COST)
            .reduce((prev, next) => prev + forceToNumber(next.total), 0)

        const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('freight')

        await dispatch(DOC_FIELD_UPDATE, {
            path: 'freight',
            data: round(freight, precision)
        })
    },

    [DOC_RECALCULATE_LINES_SPLIT]: async({dispatch, getters, rootGetters}) => {
        if (!rootGetters['doc_viewer_settings/hasLinesSplitAndTotal']) {
            return
        }
        const extension = rootGetters['doc_viewer_settings/calculateLineTotalExtension']
        let formulaKey = LineTotalCalculationFormulas.SPLIT_TOTAL_FROM_DOC_TOTAL // default
        // since there also "non-split" formulas
        if (_.get(extension, ['params', 'formulaKey']) === LineTotalCalculationFormulas.SPLIT_TOTAL_FROM_DOC_SUBTOTAL) {
            formulaKey = LineTotalCalculationFormulas.SPLIT_TOTAL_FROM_DOC_SUBTOTAL
        }
        const {total: docTotal, subtotal: docSubtotal, tax: docTax} = getDocTotalValues(getters.doc)
        let base = formulaKey === LineTotalCalculationFormulas.SPLIT_TOTAL_FROM_DOC_TOTAL
            ? docTotal
            : docSubtotal
        base = rootGetters['doc_viewer/docTaxTreatmentCode'] === TaxTreatmentCodes.EXCLUSIVE
            ? base - docTax
            : base
        let batchUpdateData = []
        let total, split, updatedSplit

        getters.lines.forEach((line, idx) => {
            if (!line || line.isDeleted) {
                return
            }
            ({total, split} = getLineValues(line))
            const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('lines.split')

            updatedSplit = base === 0
                ? 0
                : round((total / base) * 100, precision)

            if (Number(split) !== Number(updatedSplit)) {
                batchUpdateData.push({
                    idx,
                    path: 'split',
                    data: updatedSplit
                })
            }
        })

        if (batchUpdateData.length !== 0) {
            await dispatch(DOC_LINES_BATCH_UPDATE, batchUpdateData)
        }
    },

    [DOC_RECALCULATE_EACH_LINE_TOTAL]: async({dispatch, getters, rootGetters}) => {
        const formulaKey = rootGetters['doc_viewer_settings/calculateLineTotalFormulaKey']
        if (!formulaKey) {
            return
        }
        const linesBatchUpdateData = []
        const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('lines.total')
        getters.lines.forEach((line, idx) => {
            if (!line || line.isDeleted) {
                return
            }
            const total = calculateDocLineTotal({line, doc: getters.doc, formulaKey})
            if (total !== line.total) {
                linesBatchUpdateData.push({idx, path: 'total', data: round(total, precision)})
            }
        })
        if (linesBatchUpdateData.length !== 0) {
            await dispatch(DOC_LINES_BATCH_UPDATE, linesBatchUpdateData)
        }
    },

    [DOC_RECALCULATE_LINE_TOTAL]: async({dispatch, getters, rootGetters}, {idx, emittedByProp}) => {
        const formulaKey = rootGetters['doc_viewer_settings/calculateLineTotalFormulaKey']
        if (!formulaKey) {
            return
        }
        const line = getters.lines[idx]
        if (!line || line.isDeleted) {
            return
        }
        const total = calculateDocLineTotal({line, doc: getters.doc, formulaKey})
        if (total !== line.total) {
            const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('lines.total')
            await dispatch(DOC_FIELD_UPDATE, {
                idx,
                path: 'lines.total',
                data: round(total, precision)
            })
        }

        if (emittedByProp) {
            const path = `lines.${emittedByProp}`
            await dispatch(`doc_viewer_metadata/${DOC_METADATA_TOUCH_FIELD}`, {path, idx}, {root: true})
        }
    },

    [DOC_RECALCULATE_LINE_TAX]: async({dispatch, getters, rootGetters}, {idx, emittedByProp}) => {
        const formulaKey = rootGetters['doc_viewer_settings/calculateLineTaxFormulaKey']
        if (!formulaKey) {
            return
        }
        const line = getters.lines[idx]
        if (!line || line.isDeleted) {
            return
        }
        const tax = calculateDocLineTax({line, doc: getters.doc, formulaKey})
        if (tax !== line.tax) {
            const precision = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']('lines.tax')
            await dispatch(DOC_FIELD_UPDATE, {
                idx,
                path: 'lines.tax',
                data: round(tax, precision)
            })
        }

        if (emittedByProp) {
            const path = `lines.${emittedByProp}`
            await dispatch(`doc_viewer_metadata/${DOC_METADATA_TOUCH_FIELD}`, {path, idx}, {root: true})
        }
    },

    [DOC_AUTOCOMPLETE_STATEMENT_LINE_TOTALS_AND_TYPE]: async({dispatch, getters, rootGetters}, {
        idx,
        emittedByProp = 'balance'
    }) => {
        const extension = rootGetters['doc_viewer_settings/autocompleteStatementLineExtension']
        if (!extension) {
            return
        }
        const line = getters.lines[idx]
        if (!line || line.isDeleted) {
            return
        }
        const {balance, debit, credit} = getStatementLineValues(line)
        const getRoundingDecimalsByFieldPath = rootGetters['doc_viewer_settings/getRoundingDecimalsByFieldPath']

        if (emittedByProp === 'balance') {
            if (balance < 0) {
                await dispatch(DOC_FIELD_UPDATE, {
                    idx,
                    path: 'lines.credit',
                    data: round(Math.abs(balance), getRoundingDecimalsByFieldPath('lines.credit'))
                })
                await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.debit', data: 0})
            } else {
                await dispatch(DOC_FIELD_UPDATE, {
                    idx,
                    path: 'lines.debit',
                    data: round(balance, getRoundingDecimalsByFieldPath('lines.debit'))
                })
                await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.credit', data: 0})
            }
        } else if (emittedByProp === 'credit' && credit) {
            await dispatch(DOC_FIELD_UPDATE, {
                idx,
                path: 'lines.balance',
                data: round(-Math.abs(credit), getRoundingDecimalsByFieldPath('lines.balance'))
            })
            await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.debit', data: 0})
        } else if (emittedByProp === 'debit' && debit) {
            await dispatch(DOC_FIELD_UPDATE, {
                idx,
                path: 'lines.balance',
                data: round(Math.abs(debit), getRoundingDecimalsByFieldPath('lines.balance'))
            })
            await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.credit', data: 0})
        }

        if (!line.type) {
            const line = getters.lines[idx] // get updated line
            const {balance} = getStatementLineValues(line)
            if (balance < 0) {
                await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.type', data: 'Credit'})
            } else if (balance > 0) {
                await dispatch(DOC_FIELD_UPDATE, {idx, path: 'lines.type', data: 'Invoice'})
            }
        }
    },

    [DOC_FIELD_RUN_ACTIONS]: async({dispatch, getters, rootGetters}, {path, idx}) => {
        let settings = rootGetters['doc_viewer_settings/getFieldSettingsByPath'](path)
        if (!settings || !_.isArray(settings.actions) || settings.actions.length === 0) {
            return
        }
        const {prop} = getFieldPathMeta(path)

        for (const action of settings.actions) {
            if (action && typeof action.name !== 'string') {
                continue
            }

            switch (action.name) {
                case FieldActionTypes.UPDATE_ROW:
                    const line = getters.lines[idx]
                    if (!line) {
                        return
                    }
                    let actionUri = 'invoices'
                    if (getters.isSales) {
                        actionUri = 'sales'
                    } else if (getters.isStatements) {
                        actionUri = 'statements'
                    }
                    const data = {field: prop, line}
                    const lineDependencies = rootGetters['doc_viewer_settings/fields']
                        .filter(f => {
                            return (getFieldPathMeta(f.path).isLine || getFieldPathMeta(f.path).isLandedCostLine) &&
                                _.isArray(f.dependants) && f.dependants.length !== 0
                        })
                        .reduce((map, field) => {
                            map[field.path] = field.dependants.map(d => d.path)
                            return map
                        }, {})
                    if (lineDependencies.length !== 0) {
                        data.dependencies = lineDependencies
                    }
                    axios.post(`${actionUri}/${getters.doc.uuid}/action/${action.name}`, data)
                        .then(res => {
                            const newLine = res.data
                            if (_.isObject(newLine)) {
                                for (const prop in newLine) {
                                    if (prop === 'custom') {
                                        if (!_.isPlainObject(newLine[prop])) {
                                            continue
                                        }
                                        for (const customProp in newLine.custom) {
                                            dispatch(DOC_FIELD_UPDATE, {
                                                path: `lines.custom.${customProp}`,
                                                idx,
                                                data: newLine.custom[customProp]
                                            })
                                        }
                                    } else {
                                        if (rootGetters['doc_viewer_settings/visibleFields'].some(f => f.path === `lines.${prop}`)) {
                                            dispatch(DOC_FIELD_UPDATE, {
                                                path: `lines.${prop}`,
                                                idx,
                                                data: newLine[prop]
                                            })
                                        }
                                    }
                                }
                            }
                        })
                    break

                case FieldActionTypes.CHECK_PO:
                    if (!rootGetters['doc_viewer_po/purchaseOrder'] || !rootGetters['doc_viewer_po/purchaseOrder'].uuid) {
                        dispatch(`doc_viewer_po/${DOC_PO_CHECK}`, null, {root: true})
                    }
                    break

                case FieldActionTypes.RELOAD_SETTINGS:
                    dispatch(`doc_viewer_settings/${DOC_SETTINGS_SETUP_WITH_METADATA}`, null, {root: true})
                    break
            }
        }
    },

    [DOC_DUPLICATES_CHECK]: async({getters, dispatch}) => {
        if (!getters.doc.uuid || getters.isCompletedDoc) {
            return
        }
        const {error, data, _axios} = await documentApi.checkDuplicates({id: getters.doc.uuid})
        if (error) {
            if (!axios.isCancel(_axios.error)) {
                Raven.captureException(error)
            }
        } else {
            if (!!data.isDuplicate !== !!getters.doc.hasDuplicate) {
                dispatch(DOC_FIELD_UPDATE, {path: 'duplicate', data: data.duplicate})
                dispatch(DOC_FIELD_UPDATE, {path: 'hasDuplicate', data: true})
            }
        }
    },

    [DOC_ABN_CHECK]: ({getters, commit}) => {
        if (!getters.doc.uuid) {
            return
        }
        if (!getters.company.tax) {
            return commit(DOC_SET_COMPANY_FIELD, {prop: 'abn', data: null, updateMetadata: false})
        }
        return axios.post('contacts/validate/abn', {number: getters.company.tax}, {requestId: DOC_ABN_CHECK})
            .then(res => {
                commit(DOC_SET_COMPANY_FIELD, {prop: 'abn', data: res.data, updateMetadata: false})
            })
            .catch(() => {
                commit(DOC_SET_COMPANY_FIELD, {prop: 'abn', data: null, updateMetadata: false})
            })
    },

    [DOC_FETCH_RELATED_DOCUMENTS]: async({getters, commit}, doc) => {
        if (!doc) {
            doc = getters.doc
        }
        return axios.get(`documents/relates`, {
            params: {
                type: convertDocumentSectionForDocumentsAPI(doc.section),
                uuid: doc.uuid
            }
        }).then(res => {
            const data = res.data || []
            let groups
            if (_.isPlainObject(data.groups)) {
                groups = {
                    Other: [],
                    ..._.cloneDeep(data.groups)
                }
            } else {
                groups = {Other: []}
            }
            // NOTE: With added 'groups' property response has changed from array to object type
            if (data.groups) {
                delete data.groups
            }
            const docs = []
            if (_.isPlainObject(data)) {
                for (const key in data) {
                    docs.push(data[key])
                }
            } else {
                docs.concat(data.filter(el => el.uuid))
            }
            commit(DOC_SET_RELATED_DOCUMENTS, {docs, groups})
        }).catch(() => {
            commit(DOC_SET_RELATED_DOCUMENTS, {docs: [], groups: {Other: []}})
        })
    },

    [DOC_VIEWER_PRINT]: ({getters}) => {
        const pages = getters.pages
        const pdfs = pages
            .filter(asset => asset.type === AppDocPageMimeTypes.PDF)
            .map(item => item.image)

        if (pdfs.length !== 0) {
            printJS({printable: pdfs, type: 'pdf'})
            return
        }

        const imageMimeTypes = [
            AppDocPageMimeTypes.JPEG,
            AppDocPageMimeTypes.PNG,
            AppDocPageMimeTypes.IMAGE
        ]
        const images = pages
            .filter(asset => imageMimeTypes.includes(asset.type))
            .map(item => item.image)

        if (images.length !== 0) {
            printJS({printable: images, type: 'image'})
        }
        // TODO: Extract; add support for other types; separate print actions for each type
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}
